import { render, staticRenderFns } from "./RelatorioAmortizacao.vue?vue&type=template&id=204580c4"
import script from "./RelatorioAmortizacao.vue?vue&type=script&lang=js"
export * from "./RelatorioAmortizacao.vue?vue&type=script&lang=js"
import style0 from "./RelatorioAmortizacao.vue?vue&type=style&index=0&id=204580c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports